import { useState } from 'react';
import { useAuth } from '@/lib/auth';
import { X, Sparkles } from 'lucide-react';

/**
 * Bannière personnalisée d'accueil selon le rôle.
 * Se replie via × masquer (localStorage) et disparaît pour la journée.
 */
const ROLE_LABELS = {
    admin_full: { emoji: '👑', label: 'Admin Full', subtitle: "Voici l'état global de Valnexo. Ton IA surveille toutes les équipes." },
    admin: { emoji: '👑', label: 'Admin', subtitle: "Voici l'état global de Valnexo." },
    vp: { emoji: '⭐', label: 'VP', subtitle: "Focus sur ton équipe aujourd'hui." },
    apporteur: { emoji: '🎯', label: 'Apporteur', subtitle: "Voici ta journée. On abat un maximum de dossiers ensemble." },
    parrain: { emoji: '🤝', label: 'Parrain', subtitle: "Voici ta journée et l'activité de tes filleuls." },
    apprenant: { emoji: '🎓', label: 'Apprenant', subtitle: "Continue ta formation et tes premières actions." },
    comptable: { emoji: '📊', label: 'Comptable', subtitle: "Vue comptable de Valnexo." },
    community: { emoji: '📢', label: 'Community Manager', subtitle: "Anime la communauté aujourd'hui." },
};

export default function PersonalizedGreetingBanner() {
    const { user } = useAuth();
    const today = new Date().toISOString().slice(0, 10);
    const key = `vnx_greeting_dismissed_${today}`;
    const [dismissed, setDismissed] = useState(() => {
        try { return localStorage.getItem(key) === '1'; } catch { return false; }
    });

    if (dismissed || !user) return null;

    const info = ROLE_LABELS[user.role] || ROLE_LABELS.apporteur;
    const dateLabel = new Date().toLocaleDateString('fr-FR', { weekday: 'long', day: 'numeric', month: 'long' });
    const firstName = user.first_name || 'vous';

    return (
        <div
            data-testid="personalized-greeting-banner"
            className="relative rounded-2xl p-5 text-white overflow-hidden"
            style={{ background: 'linear-gradient(135deg, #5B21B6 0%, #7C3AED 50%, #A855F7 100%)' }}
        >
            <div
                className="absolute -right-8 -top-8 w-40 h-40 rounded-full blur-2xl"
                style={{ background: 'rgba(255,255,255,0.10)' }}
            />
            <button
                type="button"
                onClick={() => {
                    setDismissed(true);
                    try { localStorage.setItem(key, '1'); } catch { /* noop */ }
                }}
                className="absolute top-3 right-3 text-white/60 hover:text-white transition-colors"
                aria-label="Masquer aujourd'hui"
                data-testid="greeting-dismiss"
            >
                <X className="w-4 h-4" />
            </button>
            <div className="relative">
                <p className="text-[10px] font-bold text-white/70 uppercase tracking-widest mb-1 flex items-center gap-1.5">
                    <span>{info.emoji}</span>
                    <span>{info.label}</span>
                    <span>·</span>
                    <span className="capitalize">{dateLabel}</span>
                </p>
                <h2 className="text-2xl font-bold flex items-center gap-2">
                    Bonjour {firstName} <span className="text-xl">👋</span>
                </h2>
                <p className="text-sm text-white/90 mt-1 flex items-center gap-2">
                    <Sparkles className="w-3.5 h-3.5" /> {info.subtitle}
                </p>
            </div>
        </div>
    );
}
